import { Component } from '@angular/core';

import { SubNavItem } from '../components/sub-navigation/sub-navigation.component';

@Component({
  selector: 'bwc-vacancies',
  templateUrl: './vacancies.component.html',
  styleUrls: ['./vacancies.component.scss'],
})
export class VacanciesComponent {
  subNavItems: SubNavItem[] = [
    { label: 'vacancies.sub_nav.for_you', route: '/profile-check/vacancies' },
    // { label: 'vacancies.sub_nav.find', route: '/profile-check/vacancies/search' },
    { label: 'vacancies.sub_nav.saved', route: '/profile-check/vacancies/saved' },
  ];
}
